// The offer states OfferStatePill draws, and the tone each one reads in.
//
// Here rather than in OfferStatePill.vue because OfferCard needs the set for its
// own `offer.state` validator, and a NAMED import out of an SFC is a shape
// vue-docgen-api cannot resolve: `import OfferStatePill, { OFFER_STATES } from
// '…/OfferStatePill.vue'` made the catalog's docgen plugin throw `did not
// recognize object of type "template"` while it transformed OfferCard.vue, which
// took the whole story file down. A plain module both SFCs import has no such
// problem, and it is where every other shared constant in this package already
// lives (offerChips.js, bidCardShapes.js, planningWorksheetShapes.js).
//
// OfferStatePill.vue re-exports both names, so a caller that reads them off the
// SFC — its own story and its own test — is unchanged.
//
// Deliberately NOT exported from the package barrel: the catalog gate holds that
// a barrel exports components and nothing else.

/**
 * Each state's tone and the Tag severity that stands behind it.
 *
 * Labels are English defaults; a page that translates passes `label` to the
 * pill. Frozen, and built once for the module rather than once per instance.
 */
export const OFFER_STATE_META = Object.freeze({
  pending: { label: 'Pending', tone: 'info', severity: 'info' },
  countered: { label: 'Countered', tone: 'warning', severity: 'warn' },
  accepted: { label: 'Accepted', tone: 'success', severity: 'success' },
  declined: { label: 'Declined', tone: 'danger', severity: 'danger' },
  withdrawn: { label: 'Withdrawn', tone: 'neutral', severity: 'secondary' },
  expired: { label: 'Expired', tone: 'neutral', severity: 'secondary' },
});

/** The offer states the pill (and OfferCard) know. */
export const OFFER_STATES = Object.freeze(Object.keys(OFFER_STATE_META));

/** state → tone, for a caller that draws its own label and only needs the tint. */
export const OFFER_STATE_TONES = Object.freeze(
  Object.fromEntries(Object.entries(OFFER_STATE_META).map(([state, meta]) => [state, meta.tone])),
);
